<template>
  <div class="modal-wrapper">
    <div class="modal-backdrop"></div>
    <div class="modal-inner" :style="{alignItems: 'flex-start'}">
      <div class="edit-popup edit-popup--invoice-efd">
        <div class="edit-popup__header edit-popup__header-invoice-efd">
          <div class=""></div>
          <div class="edit-popup__close" @click="closeModal">
            <svg width="1em" height="1em" class="icon icon-close">
              <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
            </svg>
          </div>
        </div>

        <div class="title__block">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12 6C12.6628 6 13.2 6.53726 13.2 7.2V12C13.2 12.6628 12.6628 13.2 12 13.2C11.3372 13.2 10.8 12.6628 10.8 12V7.2C10.8 6.53726 11.3372 6 12 6ZM10.8 16.8C10.8 16.1372 11.3372 15.6 12 15.6H12.012C12.6748 15.6 13.212 16.1372 13.212 16.8C13.212 17.4628 12.6748 18 12.012 18H12C11.3372 18 10.8 17.4628 10.8 16.8Z" fill="#FFA51F"/>
          </svg>
          <span>Remove EFD</span>
        </div>
        
        <div class="desc__block">
          <span>Are you sure you want to remove EFD? </span>
        </div>

        <div class="btns__block">
          <button @click="closeModal" class="btn btn--silver">
            <span>Cancel</span>
          </button>
          <div @click="removedInvoiceEfd" class="btn btn--green">
            <span>Yes</span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AtModalInvoiceRemovedEfd',
  methods: {
    closeModal(){
      // console.log('closeModal')
      this.$emit('closeModalInvoiceRemovedEfdParams', false)
    },
    removedInvoiceEfd() {
      this.$emit('removedInvoiceEfdParams', true)
    }
  }
}
</script>

<style lang="scss">

  .edit-popup--invoice-efd {

    padding: 20px 35px 35px 35px;

    width: 350px;
    background: #FFFFFF;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.1);
    border-radius: 14px;

    .edit-popup__header-invoice-efd {
      //padding-bottom: 20px;

    }

    .title__block {
      display: flex;
      align-items: center;
      justify-content: center;

      margin-bottom: 20px;
      span {
        margin-left: 10px;

        font-weight: 600;
        font-size: 17px;
        line-height: 20px;

        color: #1A1A1A;
      }
    }

    .desc__block {
      display: flex;
      align-items: center;
      justify-content: center;

      padding-bottom: 40px;

      span {
        font-weight: 500;
        font-size: 15px;
        line-height: 18px;

        color: #1A1A1A;
      }
    }

    .btns__block {
      display: flex;
      justify-content: space-between;

        .back-btn {
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          margin-left: 20px;

          svg {
            width: 20px;
            height: 20px;
          }
        }

        button {
          color: #FFFFFF;
        }
      }
  }
</style>
